module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Thin.1123d09e.woff2";